export const paper = {
  MuiPaper: {
    elevation3: {
      boxShadow: "3px 3px 16px #9E9E9E40",
      position: "relative",
    },
  },
};
